import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { QuotePriceDto } from './types/quotePriceDto';
import { TransactionIsWaitingViewModel } from './types/transactionIsWaitingViewModel';

/**
 * @internal
 */
export class ApiMidbackQuote extends ApiBaseMidBack {
  @ApiOptions({ interceptErrors: false })
  postQuote(params: ParamsAdapter) {
    return this.post(`/quotes`, params);
  }

  @ApiOptions({ interceptErrors: false })
  getQuote(shortId: number) {
    return this.get<QuotePriceDto>(`/quotes/${shortId}`);
  }

  getQuoteIsWaiting(transactionIds: number[]) {
    return this.get<TransactionIsWaitingViewModel[]>(`/quotes/is-waiting`, new DefaultParams({ transactionIds }));
  }
}
